import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { auth, db } from "../services/firebase";
import { signInWithEmailAndPassword, sendEmailVerification } from "firebase/auth";
import { ref, get } from "firebase/database";
import "./TeacherLogin.css";
import { 
  FaCheckCircle, 
  FaTimesCircle, 
  FaExclamationCircle, 
  FaEnvelope, 
  FaLock,
  FaChartBar,
  FaVideo,
  FaFileAlt,
  FaExclamationTriangle
} from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const TeacherLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email.trim() || !password.trim()) {
      toast.error(<span><FaTimesCircle /> Please enter both email and password</span>);
      return;
    }

    setIsLoading(true);

    try {
      const result = await signInWithEmailAndPassword(auth, email, password);
      const user = result.user;

      if (!user.emailVerified) {
        await sendEmailVerification(user);
        toast.warning(<span><FaEnvelope /> Please verify your email. Verification link sent.</span>);
        setIsLoading(false);
        return;
      }

      const teacherRef = ref(db, `teacherRegistrations/${user.uid}`);
      const snapshot = await get(teacherRef);

      if (!snapshot.exists()) {
        toast.error(<span><FaTimesCircle /> No teacher record found. Contact admin.</span>);
        setIsLoading(false);
        return;
      }

      const teacherData = snapshot.val();
      localStorage.setItem("teacher", JSON.stringify(teacherData));

      if (teacherData.status === "pending") {
        toast.info(<span><FaExclamationCircle /> Account is pending approval. Redirecting...</span>);
       setTimeout(() => {
          navigate("/teacher-status");
        }, 5000);

      } else if (teacherData.status === "approved") {
        toast.success(<span><FaCheckCircle /> Login successful! Redirecting to dashboard...</span>);
        setTimeout(() => {
        navigate("/teacher-dashboard");
        }, 5000); 
      } else {
        toast.warning(<span><FaExclamationCircle /> Unknown status. Contact admin.</span>);
      }

      setIsLoading(false);
    } catch (err) {
      toast.error(<span><FaTimesCircle /> Login failed: {err.message}</span>);
      setIsLoading(false);
    }
  };

  return (
    <div className="tl-container-newera">
      <ToastContainer position="top-right" autoClose={4000} hideProgressBar={false} />

      {/* Left Panel */}
      <div className="tl-left-panel-newera">
        <div className="tl-form-wrapper-newera">
          <h2 className="tl-title-newera">Teacher Login</h2>
          <p className="tl-subtitle-newera">Access your proctoring dashboard</p>

          <form onSubmit={handleLogin} className="tl-form-newera">
            <div className="tl-input-wrapper-newera">
              <FaEnvelope className="tl-input-icon-newera" />
              <input
                type="email"
                placeholder="teacher@institution.edu"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="tl-input-newera"
              />
            </div>

            <div className="tl-input-wrapper-newera">
              <FaLock className="tl-input-icon-newera-password" />
              <input
                type="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="tl-input-newera"
              />
              <Link to="#" className="tl-forgot-newera">Forgot password?</Link>
            </div>

            <button type="submit" className="tl-button-newera" disabled={isLoading}>
              {isLoading ? "Signing in..." : "Sign In"}
            </button>
          </form>

          <div className="tl-info-box-newera">
            <h3>Teacher Features:</h3>
            <ul>
              <li><FaChartBar className="tl-feature-icon-newera" /> Real-time student monitoring</li>
              <li><FaVideo className="tl-feature-icon-newera" /> Live camera access</li>
              <li><FaFileAlt className="tl-feature-icon-newera" /> Detailed exam reports</li>
              <li><FaExclamationTriangle className="tl-feature-icon-newera" /> Violation alerts</li>
            </ul>
          </div>

          <div className="tl-footer-text-newera">
            Are you a student?{" "}
            <Link to="/student-login" className="tl-link-newera">Login here</Link>
            <br/> 
            <br/>
            Don't have an account?{" "}
            <Link to="/teacher-registration" className="tl-link-newera">Register now</Link>
          </div>
        </div>
      </div>


      <br/> <br/>
      {/* Right Panel */}
      <div className="tl-right-panel-newera">
        <div className="tl-branding-newera">
          <h1>BodhAI</h1>
          <p>AI Engine — New Era</p>
        </div>

        <div className="tl-dashboard-info-newera">
          <h2>Proctoring Dashboard</h2>
          <p>Monitor students in real-time, review violations, and ensure exam integrity with AI-powered proctoring tools.</p>
        </div>

        <div className="tl-stats-grid-newera">
          
            <div className="tl-stat-number-newera">50+
            <p>Active Students</p>
            </div>
          
            <div className="tl-stat-number-newera">99%
            <p>Detection Rate</p>
          </div>
          
            <div className="tl-stat-number-newera">Live
            <p>Monitoring</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeacherLogin;
